import { analytics } from "MVVM/Analytics";

export const setupNotificationAnalyticsListener = (): void => {
  if (typeof window === "undefined" || !("navigator" in window)) return;
  if (!("serviceWorker" in navigator)) return;

  try {
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data?.type === "ANALYTICS_EVENT") {
        const { eventName, properties } = event.data;

        if (
          window.rudderanalytics &&
          typeof window.rudderanalytics.track === "function"
        ) {
          window.rudderanalytics.track(eventName, properties);
        } else {
          analytics.track(eventName, properties);
        }
      }
    });
  } catch (error) {}
};

export const trackNotificationEvent = (
  eventName: string,
  properties: Record<string, unknown> = {},
): void => {
  const eventData = {
    ...properties,
    timestamp: Date.now(),
  };

  if (
    window.rudderanalytics &&
    typeof window.rudderanalytics.track === "function"
  ) {
    window.rudderanalytics.track(eventName, eventData);
  } else {
    analytics.track(eventName, eventData);
  }
};
